<template>
  <div>
  <div class="filter">
    <div class="field_left">
      <search-input
          input-class="search"
          v-model="formFields.search"
          @input="onChange"
      ></search-input>
    </div>
    <div class="field_right">
      <select-box
          id="testing"
          v-model="formFields.subscriber_type"
          :options="subscriberTypesOptions"
          @input="onChange"
      >
        <translate class="translate">Testovací odběratelé</translate>
      </select-box>
    </div>
    <div class="field_left">
      <select-box id="date_from"
                  v-model="formFields.id_report"
                  :options="datesFrom"
                  @input="onDateFromChange"
      >
        <translate class="translate">Zobrazit stav k</translate>
      </select-box>
    </div>
    <div class="field_right">
      <select-box id="date_to"
                  v-model="formFields.id_report_to"
                  :options="datesTo"
                  @input="onDateToChange"
      >
        <translate class="translate">Porovnat s reportem</translate>
      </select-box>
    </div>
    <div class="field_left">
      <select-box
          id="growthOperator"
          v-model="formFields.state_change"
          :options="stateChangeOptions"
          :disabled="!formFields.id_report_to"
          @input="onChange"
      >
        <translate class="translate">Změna stavu</translate>
      </select-box>
    </div>
    <div class="field_right">
      <select-box
          id="growthTargetOperator"
          v-model="formFields.subject_of_change"
          :options="subjectOfChangeOptions"
          :disabled="!formFields.id_report_to"
          @input="onChange"
      >
        <translate class="translate">Předmět změny stavu</translate>
      </select-box>
    </div>
    <multiselect-searchbox
        :searchFunction="searchChannelPackage"
        v-model="formFields.channel_package_ids"
        @input="onChange"
    ><translate class="translate">Balíček</translate></multiselect-searchbox>
    <div class="field_left" v-if="showChannelPackageLimitationForm">
      <p class="field checkbox_label" v-translate>Musí obsahovat</p>
      <div class="field checkboxes">
        <radio-input
            id="and"
            name="packagesLimitations"
            v-model="formFields.channel_package_limitations"
            :val="formFields.channel_package_limitations"
            @input="onChange"
        >
          <translate class="translate">všechny balíčky</translate>
        </radio-input>
        <radio-input
            id="or"
            name="packagesLimitations"
            v-model="formFields.channel_package_limitations"
            :val="formFields.channel_package_limitations"
            @input="onChange"
        >
          <translate class="translate">jeden z balíčků</translate>
        </radio-input>
      </div>
    </div>
    <div class="field_left">
    <select-box
        id="subscriberActive"
        v-model="formFields.subscriber_active"
        :options="activeOptions"
        @input="onChange"
    >
      <translate class="translate">Aktivita odběratele</translate>
    </select-box>
      </div>
    <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
    </div>
  <div class="status no_add">
    <h2 v-translate>Souhrn balíčků</h2>
  </div>
  <div class="vypis vypis_detail">
    <div class="packages packages_final">
      <ul>
        <li v-if="showChannelPackage(channelPackage)" v-for="(channelPackage, index) in channelPackagesCounts" :key="index">
          {{ channelPackage.text }} <span>{{ channelPackage.count }}</span>
          <span v-if="channelPackage.added" class="increase">(+{{channelPackage.added}})</span>
          <span v-if="channelPackage.removed" class="decrease">(-{{channelPackage.removed}})</span>
        </li>
        <li v-if="channelPackageCounts.length === 0">{{$gettext('Žádné balíčky')}}</li>
      </ul>
    </div>
  </div>
  </div>
</template>

<script>
import {SET_SETTING} from "@/store/mutation-types"
import listActions from "@/components/mixins/list-actions"

export default {
  name: "ReportsOperatorListFilter",
  mixins: [listActions],
  props:{
    filterData: Object,
    channelPackagesCounts: Array | Object,
  },
  data() {
    return {
      formFields: {
        search: "",
        subscriber_type: "t",
        id_report: null,
        id_report_to: null,
        business_model: null,
        channel_package_ids: [],
        state_change: null,
        subject_of_change: null,
        subscriber_active: true,
        channel_package_limitations: 'or',
      },
    }
  },
  computed: {
    subscriberTypesOptions() {
      return [
        {id: 't', text: this.$gettext('Včetně testovacích odběratelů')},
        {id: 'wt', text: this.$gettext('Kromě testovacích odběratelů')},
        {id: 'to', text: this.$gettext('Pouze testovací odběratelé')},
      ]
    },

    stateChangeOptions(){
      return [
        {id: null, text: this.$gettext('Všechny')},
        {id: 'growth', text: this.$gettext('Přírůstek')},
        {id: 'decrease', text: this.$gettext('Úbytek')},
      ];
    },

    subjectOfChangeOptions(){
      return [
        {id: null, text: this.$gettext('Neurčeno')},
        {id: 'channel_package_count', text: this.$gettext('Počet balíčků')},
        {id: 'paidDeviceCount', text: this.$gettext('Počet simultánně streamujících zařízení nad limit')},
        {id: 'firstscreenDeviceAboveLimitCount', text: this.$gettext('Počet firstscreen zařízení nad limit')},
      ];
    },

    subjectOfChangeIds(){
      return this.subjectOfChangeOptions.map(item => item.id);
    },

    activeOptions(){
      return [
        {id: null, text: this.$gettext('Všechny')},
        {id: true, text: this.$gettext('Pouze aktivní')},
        {id: false, text: this.$gettext('Pouze neaktivní')},
      ];
    },

    datesFrom(){
      return "report_dates" in this.filterData? this.filterData["report_dates"] : [];
    },

    datesTo(){
      let options = "report_dates" in this.filterData? [...this.filterData["report_dates"]] : [];
      options = options.filter((item)=>{
        return item.id < this.formFields.id_report;
      })
      options.unshift({id: null, text: this.$gettext('Neurčeno')})
      return options;
    },
    channelPackageCounts(){
      let packages = [];
      if(this.filterData.hasOwnProperty("operator_data")){
        for(let packageId in this.filterData.operator_data.used_channel_packages){
          let count = this.filterData.operator_data.used_channel_packages[packageId][this.formFields.subscriber_type];
          if(count > 0){
            packages.push({id: packageId, text: this.filterData.operator_data.channel_packages[packageId].name, count: count});
          }
        }
      }

      return packages;
    },
    showChannelPackageLimitationForm() {
      return this.formFields.channel_package_ids.length > 1;
    }
  },
  methods:{
    getEntities() {
    },
    setDefault(defaults){
      this.formFields = {...this.formFields, ...defaults};
      this.formFieldsDefaults = {...this.formFields};
      this.loadAdditionalDefaults(defaults);
      this.onChange();
    },
    onDateFromChange(){
      this.formFields.id_report_to = null;
      this.$router.push({name: 'reportsOperator', params: {id_report:this.formFields.id_report}})
      this.onDateToChange();
    },
    onDateToChange(){
      if(this.formFields.id_report_to == null){
        this.formFields.state_change = null;
        this.formFields.subject_of_change = null;
      }
      this.onChange();
    },
    saveFilterValues() {
      this.setCustomUserSetting('subscriber_type', this.formFields.subscriber_type)
      this.setCustomUserSetting('id_report', this.formFields.id_report)
      this.setCustomUserSetting('id_report_to', this.formFields.id_report_to)
      this.setCustomUserSetting('state_change', this.formFields.state_change)
      this.setCustomUserSetting('subject_of_change', this.formFields.subject_of_change)
      this.setCustomUserSetting('subscriber_active', this.formFields.subscriber_active)
    },
    setCustomUserSetting(settingKey, settingValue) {
      this.$store.dispatch(SET_SETTING, {module: 'reports', settings: settingValue, key: settingKey})
    },
    loadAdditionalDefaults(defaults) {
      let anyChanges = false
      if (this.loadCustomDefaultByKey('subscriber_type', defaults)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('id_report', defaults)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('id_report_to', defaults)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('state_change', defaults)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('subject_of_change', defaults, this.subjectOfChangeIds)) {
        anyChanges = true
      }
      if (this.loadCustomDefaultByKey('subscriber_active', defaults)) {
        anyChanges = true
      }
      if(anyChanges){
        this.onChange();
      }
      return anyChanges
    },
    loadCustomDefaultByKey(settingKey, defaults, allowedValues = null) {
      let data = {module: 'reports', key: settingKey}
      if (this.$store.getters.hasSetting(data)) {
        if(!defaults.hasOwnProperty(settingKey) || !defaults[settingKey]) {
          let value = this.$store.getters.getSetting(data);
          if(!allowedValues || (allowedValues.isArray && allowedValues.includes(value))) {
            this.formFields[settingKey] = value;
            return true;
          }
        }
      }
      return false
    },
    onChange(){
      this.saveFilterValues();
      this.$emit('onChange', this.formFields);
    },
    searchChannelPackage(data, selectAll = false) {
      return new Promise((resolve, reject) => {
        resolve({success: true, data: this.channelPackageCounts.filter((item) => {
          return item.count > 0
              && item.text.normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, "")
                  .toLowerCase()
                  .includes(data.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase());
        })
        });
      });
    },
    showChannelPackage(data){
      return data.count !==0 || data.added !== 0 || data.removed !==0;
    },
    resetFilter(){
      this.formFields = {...this.formFieldsDefaults};
      this.onChange();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/reports/ReportsOperatorListFilter.vue